module.exports = __webpack_public_path__ + "static/media/so-algo-goat1.8970fb3d.jpg";